export function download(url, name) {
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      const underscoredName = name.trim().replace(/\s+/g, "_");

      const a = document.createElement("a");
      a.download = `${underscoredName}.mp4`;
      a.href = blobUrl;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(e => alert(`Error: ${e.message}`));
}



// WEBPACK FOOTER //
// ./src/utils/downloadUtil.js